// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IApplyUnmatchedInvoicesRequestDto,
  ICountryInfoDto,
  IErrorDto,
  IGenericErrorDto,
  IInvoiceType,
  IPageUnappliedPushInvoiceDto,
  IStateInfoDto,
  ITransactorInfoDto,
} from '../models/index';
import {
    IApplyUnmatchedInvoicesRequestDtoFromJSON,
    IApplyUnmatchedInvoicesRequestDtoToJSON,
    ICountryInfoDtoFromJSON,
    ICountryInfoDtoToJSON,
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IGenericErrorDtoFromJSON,
    IGenericErrorDtoToJSON,
    IInvoiceTypeFromJSON,
    IInvoiceTypeToJSON,
    IPageUnappliedPushInvoiceDtoFromJSON,
    IPageUnappliedPushInvoiceDtoToJSON,
    IStateInfoDtoFromJSON,
    IStateInfoDtoToJSON,
    ITransactorInfoDtoFromJSON,
    ITransactorInfoDtoToJSON,
} from '../models/index';

export interface ApplyUnmatchedInvoicesRequest {
    iApplyUnmatchedInvoicesRequestDto: IApplyUnmatchedInvoicesRequestDto;
}

export interface GetStateInfoDtoByNameRequest {
    name?: string;
}

export interface GetTransactorRequest {
    transactorId: number;
}

export interface SearchUnappliedPushInvoicesRequest {
    invoiceTypes?: Set<IInvoiceType>;
    searchInput?: string;
    organizationId?: number;
}

/**
 * InvoiceServiceServiceApi - interface
 * 
 * @export
 * @interface InvoiceServiceServiceApiInterface
 */
export interface InvoiceServiceServiceApiInterface {
    /**
     * Validates the requested invoices, transitions them to PAYMENT_INITIATED and publishes a message to process the manual application of the unmatched invoices.
     * @summary Apply unmatched push invoices
     * @param {IApplyUnmatchedInvoicesRequestDto} iApplyUnmatchedInvoicesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceServiceServiceApiInterface
     */
    applyUnmatchedInvoicesRaw(requestParameters: ApplyUnmatchedInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validates the requested invoices, transitions them to PAYMENT_INITIATED and publishes a message to process the manual application of the unmatched invoices.
     * Apply unmatched push invoices
     */
    applyUnmatchedInvoices(requestParameters: ApplyUnmatchedInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get all existing Country types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceServiceServiceApiInterface
     */
    getCountryTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ICountryInfoDto>>>;

    /**
     * Get all existing Country types
     */
    getCountryTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ICountryInfoDto>>;

    /**
     * 
     * @summary Get State list by name
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceServiceServiceApiInterface
     */
    getStateInfoDtoByNameRaw(requestParameters: GetStateInfoDtoByNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IStateInfoDto>>>;

    /**
     * Get State list by name
     */
    getStateInfoDtoByName(requestParameters: GetStateInfoDtoByNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IStateInfoDto>>;

    /**
     * 
     * @param {number} transactorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceServiceServiceApiInterface
     */
    getTransactorRaw(requestParameters: GetTransactorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ITransactorInfoDto>>;

    /**
     */
    getTransactor(requestParameters: GetTransactorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ITransactorInfoDto>;

    /**
     * Paginated list of unpaid push invoices for the current org. Filters: invoice types (default all allowed types) and free-text searchInput (invoice id or amount). Sorted by the date the invoice first entered PAYMENT_REQUESTED, oldest to newest.
     * @summary Search unapplied push invoices
     * @param {Set<IInvoiceType>} [invoiceTypes] 
     * @param {string} [searchInput] 
     * @param {number} [organizationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceServiceServiceApiInterface
     */
    searchUnappliedPushInvoicesRaw(requestParameters: SearchUnappliedPushInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageUnappliedPushInvoiceDto>>;

    /**
     * Paginated list of unpaid push invoices for the current org. Filters: invoice types (default all allowed types) and free-text searchInput (invoice id or amount). Sorted by the date the invoice first entered PAYMENT_REQUESTED, oldest to newest.
     * Search unapplied push invoices
     */
    searchUnappliedPushInvoices(requestParameters: SearchUnappliedPushInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageUnappliedPushInvoiceDto>;

}

/**
 * 
 */
export class InvoiceServiceServiceApi extends runtime.BaseAPI implements InvoiceServiceServiceApiInterface {

    /**
     * Validates the requested invoices, transitions them to PAYMENT_INITIATED and publishes a message to process the manual application of the unmatched invoices.
     * Apply unmatched push invoices
     */
    async applyUnmatchedInvoicesRaw(requestParameters: ApplyUnmatchedInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iApplyUnmatchedInvoicesRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iApplyUnmatchedInvoicesRequestDto',
                'Required parameter "iApplyUnmatchedInvoicesRequestDto" was null or undefined when calling applyUnmatchedInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/invoices/apply-unmatched`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IApplyUnmatchedInvoicesRequestDtoToJSON(requestParameters['iApplyUnmatchedInvoicesRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validates the requested invoices, transitions them to PAYMENT_INITIATED and publishes a message to process the manual application of the unmatched invoices.
     * Apply unmatched push invoices
     */
    async applyUnmatchedInvoices(requestParameters: ApplyUnmatchedInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.applyUnmatchedInvoicesRaw(requestParameters, initOverrides);
    }

    /**
     * Get all existing Country types
     */
    async getCountryTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ICountryInfoDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/enums/countries`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ICountryInfoDtoFromJSON));
    }

    /**
     * Get all existing Country types
     */
    async getCountryTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ICountryInfoDto>> {
        const response = await this.getCountryTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get State list by name
     */
    async getStateInfoDtoByNameRaw(requestParameters: GetStateInfoDtoByNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IStateInfoDto>>> {
        const queryParameters: any = {};

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/enums/states`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IStateInfoDtoFromJSON));
    }

    /**
     * Get State list by name
     */
    async getStateInfoDtoByName(requestParameters: GetStateInfoDtoByNameRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IStateInfoDto>> {
        const response = await this.getStateInfoDtoByNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTransactorRaw(requestParameters: GetTransactorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ITransactorInfoDto>> {
        if (requestParameters['transactorId'] == null) {
            throw new runtime.RequiredError(
                'transactorId',
                'Required parameter "transactorId" was null or undefined when calling getTransactor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/transactors/{transactor-id}`;
        urlPath = urlPath.replace(`{${"transactor-id"}}`, encodeURIComponent(String(requestParameters['transactorId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ITransactorInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async getTransactor(requestParameters: GetTransactorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ITransactorInfoDto> {
        const response = await this.getTransactorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Paginated list of unpaid push invoices for the current org. Filters: invoice types (default all allowed types) and free-text searchInput (invoice id or amount). Sorted by the date the invoice first entered PAYMENT_REQUESTED, oldest to newest.
     * Search unapplied push invoices
     */
    async searchUnappliedPushInvoicesRaw(requestParameters: SearchUnappliedPushInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageUnappliedPushInvoiceDto>> {
        const queryParameters: any = {};

        if (requestParameters['invoiceTypes'] != null) {
            queryParameters['invoiceTypes'] = requestParameters['invoiceTypes'];
        }

        if (requestParameters['searchInput'] != null) {
            queryParameters['searchInput'] = requestParameters['searchInput'];
        }

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/invoices/search-unapplied-push`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageUnappliedPushInvoiceDtoFromJSON(jsonValue));
    }

    /**
     * Paginated list of unpaid push invoices for the current org. Filters: invoice types (default all allowed types) and free-text searchInput (invoice id or amount). Sorted by the date the invoice first entered PAYMENT_REQUESTED, oldest to newest.
     * Search unapplied push invoices
     */
    async searchUnappliedPushInvoices(requestParameters: SearchUnappliedPushInvoicesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageUnappliedPushInvoiceDto> {
        const response = await this.searchUnappliedPushInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
